/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { FaLinkedin, FaMedium } from "react-icons/fa";
import { BACKEND_CSS, FRONTEND_CSS, INFRASTRUCTURE_CSS, MOBILE_CSS, OTHERS_CSS } from "../constant";
import Tag from "./Tag";
import Aos from "aos";
import "aos/dist/aos.css";

const speedFactor = 2;
function Skill({ children, ...restProps }) {

  useEffect(() => {
    Aos.init({duration: 100});
  
  }, [])
  return (

    <div className="p-4 md:p-12 mx-auto w-full bg-white lg:py-4 border rounded-lg " data-aos="fade-up" data-aos-duration="400">
      <div class="flex justify-center font-sans text-3xl font-bold leading-none tracking-tight text-center text-gray-900 b-6 sm:text-4xl md:mx-auto "  data-aos="fade-right" data-aos-duration="500">
            <span class="relative">Skills</span> </div>
            <div className="">
            <div className="my-8">
            <h2
            class="flex font-sans text-xl font-bold leading-none tracking-tight  text-gray-900 b-6 sm:text-2xl md:mx-auto my-2">
            <span class="relative" data-aos="fade-left" data-aos-duration="100">Frontend</span> </h2>
            <div className="grid grid-cols-2 md:flex md:flex-row">
            {["Javascript", "React JS", "Redux", "Redux Saga",  "Next JS", "Angular", "TailwindCSS",  "Laravel", "HTML", "CSS", "Bootstrap"].map((x,index) => 
            (<div data-aos="fade-left" data-aos-duration={100 * (index + speedFactor)}><Tag value={x} classes={FRONTEND_CSS} /></div>))}
            </div>
            </div>

            <div className="my-8">
            <h2
            class="flex font-sans text-xl font-bold leading-none tracking-tight  text-gray-900 b-6 sm:text-2xl md:mx-auto my-2">
            <span class="relative" data-aos="fade-left" data-aos-duration="100">Backend</span> </h2>
            <div className="grid grid-cols-2 md:flex md:flex-row">
            {[ ". NET Core", ". NET", "PHP", "Postgres", "SQL", "MYSQL", "MongoDB"].map((x,index) =>     
             (<div data-aos="fade-left" data-aos-duration={100 * (index + speedFactor)}><Tag value={x} classes={BACKEND_CSS} /></div>))}
            </div>
            </div>


            <div className="my-8">
            <h2
            class="flex font-sans text-xl font-bold leading-none tracking-tight  text-gray-900 b-6 sm:text-2xl md:mx-auto my-2">
            <span class="relative" data-aos="fade-left" data-aos-duration="100">Mobile</span> </h2>
            <div className="grid grid-cols-2 md:flex md:flex-row">
            {[ "React Native", "Android"].map((x,index) =>
                     (<div data-aos="fade-left" data-aos-duration={100 * (index + speedFactor)}><Tag value={x} classes={MOBILE_CSS} /></div>))}
            </div>
            </div>

            <div className="my-8">
            <h2
            class="flex font-sans text-xl font-bold leading-none tracking-tight  text-gray-900 b-6 sm:text-2xl md:mx-auto my-2">
            <span class="relative" data-aos="fade-left" data-aos-duration="100">Infrastructure</span> </h2>
            <div className="grid grid-cols-2 md:flex md:flex-row">
            {["AWS", "Azure", "Google Cloud", "Firebase"].map((x,index) => 
              (<div data-aos="fade-left" data-aos-duration={100 * (index + speedFactor)}><Tag value={x} classes={INFRASTRUCTURE_CSS} /></div>))}
            </div>
            </div>

          
            <div className="my-8">
            <h2
            class="flex font-sans text-xl font-bold leading-none tracking-tight  text-gray-900 b-6 sm:text-2xl md:mx-auto my-2">
            <span class="relative" data-aos="fade-left" data-aos-duration="100">Others</span> </h2>
            <div className="grid grid-cols-2 md:flex md:flex-row">
            {["GIT", "Jenkins", "DevOps", "Github"].map((x, index) =>
              (<div data-aos="fade-left" data-aos-duration={100 * (index + speedFactor)}><Tag value={x} classes={OTHERS_CSS} /></div>))}
            </div>
            </div>
            </div>
</div>

  );
}

export default Skill;